import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { Environment } from 'src/app/types';
import { ENVIRONMENT } from 'src/app/constants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  loginForm!: FormGroup;
  showDateAlert = false;
  workTimeDate: string[] = [];
  qrCodeToken: string | null = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    @Inject(ENVIRONMENT) public environment: Environment
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      senha: ['', [Validators.required]]
    });

    this.qrCodeToken = this.route.snapshot.queryParamMap.get('token');

    this.verifySpecialDate();
  }

  doLogin(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    this.subscriptions$.add(
      this.authService.loginUsuario(this.loginForm.getRawValue()).subscribe({
        next: () => {
          if (this.qrCodeToken) {
            sessionStorage.setItem('qrCodeToken', this.qrCodeToken);
            this.router.navigate(['/equipamento/abrir-chamado/1']);
            return;
          }

          this.router.navigate(['/dashboard']);
        }
      })
    );
  }

  private verifySpecialDate(): void {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const lastSpecialDate = new Date(2026, 6, 9);
    lastSpecialDate.setHours(0, 0, 0, 0);

    if (today > lastSpecialDate) {
      this.showDateAlert = false;
      return;
    }

    this.showDateAlert = true;
    this.workTimeDate = [
      'Dia 09/07/2026, devido feriado estadual em São Paulo - Revolução Constitucionalista de 1932 - não haverá expediente na KM do Brasil.',
      'Retornaremos no dia 10/07/2026 em horário comercial.'
    ];
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
